import React, { RefObject, useRef } from 'react';
import { useDateRangeValidation } from './useDateRangeValidation';
import { Row } from '../../grid/Row/Row';
import { Input } from '../Input/Input';

type BasicRange = {
  start: any;
  end: any;
  labelStart: string;
  labelEnd: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  dateRangeTypeDependentValidation?: (
    startRef: RefObject<HTMLInputElement | null>,
    endRef: RefObject<HTMLInputElement | null>,
  ) => void;
};

const getValueForDateType = (type: 'date' | 'datetime' | 'datetime-local' | 'time' | undefined, value?: string) => {
  return type === 'date' ? value?.split('T')[0] : value;
};

/**
 * Date Range to switch between date-time and datetime-local types.
 *
 * value here is always given in datetime-local format from BE.
 * TODO: need to keep time somewhere in state so we dont lose input while switching.
 */
export function BasicRange({ labelStart, labelEnd, start, end, onBlur, dateRangeTypeDependentValidation }: BasicRange) {
  const startRef = useRef<HTMLInputElement>(null);
  const endRef = useRef<HTMLInputElement>(null);

  const validation = useDateRangeValidation(startRef, endRef, dateRangeTypeDependentValidation);
  const onBlurEventHandler = (event: React.FocusEvent<HTMLInputElement, Element>) => {
    validation();
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  };

  return (
    <Row modifier="row--grid-2-columns">
      <Input
        label={labelStart}
        param={start}
        ref={startRef}
        onBlur={onBlurEventHandler}
        defaultValue={getValueForDateType(start?.type, start?.value)}
      />
      <Input
        label={labelEnd}
        param={end}
        ref={endRef}
        onBlur={onBlurEventHandler}
        defaultValue={getValueForDateType(end?.type, end?.value)}
      />
    </Row>
  );
}
